import debounce from 'lodash/debounce';

function formatSToMSS(sec) {
  let s = Math.round(sec);
  return (s - (s %= 60)) / 60 + (s > 9 ? ':' : ':0') + s;
}

let interval = null;

export default {
  props: {
    audio: { default: null, type: String },
    cta: { default: '', type: String },
  },
  data() {
    return {
      audioElm: null,
      playing: false,
      duration: 0,
      currentTime: 0,
      playable: false,
      started: false,
    };
  },
  mounted() {
    this.initAudio();
  },
  computed: {
    durationString() {
      return formatSToMSS(this.duration);
    },
    timeString() {
      return formatSToMSS(this.currentTime);
    },
  },
  watch: {
    playing: debounce(function (play) {
      if (!play) {
        clearInterval(interval);
      } else {
        interval = setInterval(() => {
          if (!this.audioElm || !this.playing) return;
          this.currentTime = this.audioElm.currentTime;
        }, 300);
      }
    }, 200),
  },
  methods: {
    initAudio() {
      this.audioElm = this.$refs.audio;

      this.audioElm.addEventListener('loadeddata', () => {
        this.duration = this.audioElm.duration;
      });
      this.audioElm.addEventListener('canplaythrough', () => {
        this.playable = true;
        this.duration = this.audioElm.duration;
      });
      // If audio already ready
      if (this.audioElm.readyState > 3) {
        this.playable = true;
        this.duration = this.audioElm.duration;
      }

      this.audioElm.load();
    },
    play() {
      if (!this.audioElm || !this.playable) return;

      this.audioElm.play();
      this.playing = true;
      this.started = true;

      this.audioElm.addEventListener('ended', this.resetPlayer);
    },
    pause() {
      if (!this.audioElm) return;
      this.audioElm.pause();
      this.playing = false;
    },
    resetPlayer() {
      this.pause();
      this.started = false;
      setTimeout(() => {
        this.currentTime = 0;
      }, 50);
    },
  },
  template: '#fragrance-max-audio-single',
};
